import { render, staticRenderFns } from "./public-comp-card-wrapper-v2.vue?vue&type=template&id=0416f063&"
import script from "./public-comp-card-wrapper-v2.vue?vue&type=script&lang=ts&"
export * from "./public-comp-card-wrapper-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports